module.exports = __webpack_public_path__ + "img/pulldownIcon_hover.21ca6fc0.svg";